import SpeedIcon from "@mui/icons-material/Speed";
import StorageIcon from "@mui/icons-material/Storage";
import GroupIcon from "@mui/icons-material/Group";
import ExtensionIcon from "@mui/icons-material/Extension";

export const getCategoryIcon = (featureCode: string) => {
  const code = (featureCode || "").toLowerCase();
  if (
    code.includes("message") ||
    code.includes("msg") ||
    code.includes("rate")
  )
    return <SpeedIcon />;
  if (code.includes("storage") || code.includes("disk"))
    return <StorageIcon />;
  if (
    code.includes("connection") ||
    code.includes("conn") ||
    code.includes("concurrent")
  )
    return <GroupIcon />;
  return <ExtensionIcon />;
};

export const formatFeatureCode = (code?: string) =>
  code?.replace(/_/g, " ") ?? "";
